import { Link } from 'react-router';
import { PageHeader } from '../components/page-header.js';

export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Página no encontrada" description="La dirección que buscas no existe." />
      <Link to="/" className="font-medium text-accent underline">
        Volver al catálogo
      </Link>
    </>
  );
}
